export enum CloudProvider {
  NotCloud = "NotCloud",
  AWS = "AWS",
}
